import React from "react";
import BondRepayment from "./BondRepayment";
import CalculatorSeoSection from "./CalculatorSeoSection";
import LoanCalculatorTabs from "./LoanCalculatorTabs";
import AdSenseSlot from "./AdSenseSlot";
import SiteFooter from "./SiteFooter";
import type { CalculationType } from "../utils/api";
import "./Affordability.css";

interface BondRepaymentPageProps {
  onOpenAuthForSave?: (callback: () => void) => void;
  onOpenAuth?: () => void;
  pendingRestore?: {
    type: CalculationType;
    payload: Record<string, unknown>;
    calculationId?: string;
    name?: string;
    createdAt?: string;
  } | null;
  onClearPendingRestore?: () => void;
}

const BondRepaymentPage: React.FC<BondRepaymentPageProps> = ({
  onOpenAuthForSave,
  onOpenAuth,
  pendingRestore,
  onClearPendingRestore,
}) => (
  <main className="affordability">
    <div className="calculator-container">
      <div className="calculator-title-row">
        <div>
          <h1>Bond Repayment Calculator</h1>
          <p className="subtitle">
            Model repayments, extra payments, lump sums, and rate changes on your home loan.
          </p>
        </div>
      </div>
      <LoanCalculatorTabs />
      <div className="calculator-section calculator-section-bond">
        <BondRepayment
          hideTitle
          onOpenAuthForSave={onOpenAuthForSave}
          onOpenAuth={onOpenAuth}
          pendingRestore={
            pendingRestore?.type === "bond" ? pendingRestore.payload : undefined
          }
          onClearPendingRestore={onClearPendingRestore}
        />
      </div>
      <AdSenseSlot className="AdSenseSlot-wrapper--in-panel" />
      <CalculatorSeoSection variant="bond" />
      <SiteFooter />
    </div>
  </main>
);

export default BondRepaymentPage;
